// extracted by mini-css-extract-plugin
module.exports = {"container":"about__container","textContainer":"about__textContainer"};